
import {
  defineComponent,
  PropType,
  ref,
  SetupContext,
  watch,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Tooltip from 'primevue/tooltip';
import Dropdown from 'primevue/dropdown';
import { StringMap } from '@/types';

export default defineComponent({
  name: 'BaseDropdown2',

  components: {
    Dropdown,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    modelValue: {
      type: [Array, String, Number] as PropType<string[] | string | number>,
      required: true,
    },

    classes: {
      type: String,
      required: false,
      default: '',
    },

    options: {
      type: Object as PropType<StringMap>,
      required: true,
    },

    title: {
      type: String,
      required: false,
      default: '',
    },

    placeholder: {
      type: String,
      required: false,
      default: '',
    },

    tooltipDesc: {
      type: String,
      required: false,
      default: '',
    },
  },

  emits: ['update:modelValue'],

  setup(props: { modelValue: string[] | string | number}, { emit }: SetupContext) {
    const { t } = useI18n();

    const val = ref(props.modelValue);

    watch([val], () => emit('update:modelValue', val.value));

    return {
      t,
      val,
    };
  },
});
